var map = {
	"./README.md": 72793,
	"./dao_create.png": 48791,
	"./dao_description.png": 39449,
	"./dao_how_to_create_a_proposal_on_tezos.png": 91301,
	"./dao_select_template.png": 76718,
	"./dao_settings.png": 46703,
	"./how_to_create_dao_on_tezos.png": 89518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91722;